import styled from 'styled-components';
import { IconButton } from '@web-chat-core/ui-kit';

export const ToggleAdditionalMenuButton = styled(IconButton)`
    height: 40px;
    width: 40px;

    &:before {
        background: ${(props) => props.theme.root.colors.basicColors['10%']};
    }

    &:hover:before {
        background: ${(props) => props.theme.root.colors.basicColors['15%']};
    }
`;
